import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Acceso",
  "lead": "En el plano mundial, el 88% de los niños finaliza la escuela primaria, el 78% de los adolescentes el primer ciclo de secundaria, y el 59% de los jóvenes el segundo ciclo de secundaria."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, Highlight, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!Highlight) _missingMdxReference("Highlight", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_ACCESS"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "El mundo no cumplió su promesa de que todos los niños y niñas asistieran a la escuela primaria en 2015. El nuevo objetivo en materia de educación, el ODS 4, ha subido aún más el listón, exigiendo que todos los jóvenes terminen la escuela secundaria antes de la fecha límite de 2030. Para lograrlo, todos los niños en edad escolar deberían haber comenzado a asistir a la escuela en 2018, pero en realidad, este era el caso solamente del 70% en los países de bajos ingresos, por ejemplo."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "asistencia-a-la-educación-preescolar",
      children: "Asistencia a la educación preescolar"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.2.2",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "La asistencia a la educación preescolar"
        }), " es un punto de partida decisivo del camino de los niños a lo largo de la educación. No obstante, en los países de bajos ingresos, solo el 48 % de los niños están matriculados en el año anterior a la edad oficial de ingreso a la educación primaria."]
      })
    }), "\n", _jsx(_components.p, {
      children: "A nivel mundial, la participación en el año previo a la escuela primaria aumentó del 64 % en 2003 al 75 % en 2024, impulsada principalmente por los avances a principios de la década de 2000. El progreso se ha estancado en gran medida desde 2015, dejando a muchos niños sin acceso a la educación preescolar."
    }), "\n", _jsx(_components.p, {
      children: "En algunos países se han observado mejoras considerables. En Azerbaiyán, por ejemplo, la tasa de participación aumentó del 16% en 2000 al 83% en 2024. En la República Democrática Popular Lao, se incrementó del 10% al 67% en el mismo período."
    }), "\n", _jsx("p", {
      children: _jsxs(_components.p, {
        children: ["La ", _jsx(HighlightByIndex, {
          index: "0",
          children: "República Dominicana"
        }), " y el\n", _jsx(HighlightByIndex, {
          index: "1",
          children: "Senegal"
        }), ", que se presentan más\nadelante, son dos ejemplos de países que han experimentado un aumento\nconstante de la asistencia a la educación preescolar, a pesar de que hoy en\ndía hay enormes disparidades entre ambos. Seleccione su país para ver sus\navances."]
      })
    }), "\n", _jsx(_components.p, {
      children: "Tres de cada cuatro niños asisten a la educación preescolar el año antes de ingresar en la educación primaria"
    }), "\n", _jsx(Figure, {
      id: "PREPRIM"
    }), "\n", _jsx(_components.h2, {
      id: "participación-a-una-edad-superior-a-la-normal",
      children: "Participación a una edad superior a la normal"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.5",
      children: _jsxs(_components.p, {
        children: ["No evocamos suficientemente la cuestión de que en algunos países más de una cuarta parte de los alumnos de primaria ", _jsx(_components.strong, {
          children: "supera la edad para el grado"
        }), " al matricularse, lo que significa que su edad excede considerablemente a la que sería normal para su grado. Esto repercute en gran medida en su futuro, aumentando la probabilidad de repetir grados, suspender los exámenes y finalmente abandonar la escuela."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["En este gráfico sobre la ", _jsx(_components.strong, {
        children: "participación en la educación"
      }), ", se señala la edad de los niños, adolescentes y jóvenes cuando cursan la educación preescolar, primaria, de primer y segundo ciclo de secundaria, y terciaria. Los distintos colores indican cuántos niños han superado la edad para su nivel educativo. La zona sombreada en gris muestra el porcentaje de niños y adolescentes sin escolarizar por edad."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "OVERAGE"
        })
      }), _jsx(ScrollySection, {
        id: "KHM",
        children: _jsxs(_components.p, {
          children: ["En el ", _jsx(Highlight, {
            children: "Camboya"
          }), ", la mayoría de los niños de 10 años\ndebería ir a la escuela, pero el 21% sigue fuera de ella a esa edad. Muchos\nson demasiado mayores para su grado. Hay por ejemplo alumnos de 14 años aún\nen la escuela primaria."]
        })
      }), _jsx(ScrollySection, {
        id: "LBR",
        children: _jsxs(_components.p, {
          children: ["La tasa de edad superior al grado es incluso mayor en países como", " ", "\n", _jsx(Highlight, {
            children: "Liberia"
          }), ", donde el 28% de los niños de 10 años está en\npreescolar, y el 20% de los jóvenes de 19 años está aún en la escuela\nprimaria."]
        })
      }), _jsx(ScrollySection, {
        id: "NPL",
        children: _jsxs(_components.p, {
          children: [_jsx(Highlight, {
            children: "Nepal"
          }), " se enfrenta al mismo problema"]
        })
      }), _jsx(ScrollySection, {
        id: "MWI",
        children: _jsxs(_components.p, {
          children: ["al igual que ", _jsx(Highlight, {
            children: "Malawi"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "niños-sin-escolarizar",
      children: "Niños sin escolarizar"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.4",
      children: [_jsxs(_components.p, {
        children: ["En el plano mundial, 273 millones de niños y jóvenes ", _jsx(_components.strong, {
          children: "no están escolarizados"
        }), ". Un ", _jsx(_components.a, {
          href: "https://www.education-estimates.org",
          children: "nuevo modelo desarrollado por el Instituto de Estadística de la UNESCO y el Informe de seguimiento de la educación en el mundo"
        }), " indica que la población fuera del sistema escolar ha aumentado en los últimos años."]
      }), _jsx(_components.p, {
        children: "Los conflictos son una de las causas principales de este estancamiento. Lamentablemente, éstos también producen un deterioro de la disponibilidad y la calidad de los datos, aunque algunos países siguen comunicando estimaciones."
      }), _jsx(_components.p, {
        children: "Las tasas de no escolarización han  descendido, pero a un ritmo más lento"
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "OOSRATE"
          })
        }), _jsx(ScrollySection, {
          id: "ECU,PRY",
          children: _jsxs(_components.p, {
            children: ["Los progresos de ", _jsx(Highlight, {
              children: "Ecuador"
            }), " y ", _jsx(Highlight, {
              children: "Paraguay"
            }), " han seguido\nvías muy diferentes. Dentro de la educación secundaria, la tasa de no\nescolarización en Ecuador ha caído en picado, mientras que en Paraguay ha aumentado."]
          })
        }), _jsx(ScrollySection, {
          id: "ERI,ETH",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "Eritrea"
            }), " y ", _jsx(Highlight, {
              children: "Etiopía "
            }), " también muestran tasas de\nprogreso muy diferentes. Las secuelas del conflicto en Eritrea afectaron visiblemente el acceso\na la educación, mientras que Etiopía ha dado prioridad a la educación en su presupuesto, lo que\nha conducido a una rápida reducción de la tasa de niños fuera de la escuela en primaria."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Otra razón de que no se avance en la reducción del número de niños sin escolarizar es el crecimiento de la población."
    }), "\n", _jsxs(_components.p, {
      children: ["En África Subsahariana, ", _jsx(HighlightByIndex, {
        index: "2",
        children: "la población en edad de cursar educación"
      }), " primaria prácticamente se ha duplicado entre 2000 y 2024. En consecuencia, aunque ", _jsx(HighlightByIndex, {
        index: "0",
        children: "la tasa de niños sin escolarizar"
      }), " se ha reducido casi a la mitad durante este período, ", _jsx(HighlightByIndex, {
        index: "1",
        children: "el número de niños sin escolarizar "
      }), " apenas ha cambiado."]
    }), "\n", _jsx(Figure, {
      id: "OOSREL"
    }), "\n", _jsx(_components.h2, {
      id: "finalización",
      children: "Finalización"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.2",
      children: [_jsxs(_components.p, {
        children: ["El objetivo final del ODS 4 es la ", _jsx(_components.strong, {
          children: "finalización"
        }), " universal del segundo ciclo de la educación secundaria, y no solo la matriculación, a pesar de que, en muchos países, la educación únicamente es gratuita y obligatoria hasta el primer ciclo de la educación secundaria, como mucho."]
      }), _jsx(_components.p, {
        children: "El mundo no está ni siquiera bien encaminado para lograr la finalización universal de la educación primaria en el plazo previsto, y por tanto mucho menos la finalización del segundo ciclo de la secundaria. Según las tendencias actuales, menos de dos de cada tres jóvenes terminarán la escuela secundaria en 2030."
      }), _jsxs(_components.p, {
        children: ["El indicador se refiere a los niños que pudieran finalizar los ciclos de educación hasta 3 o 5 años después de la edad oficial de graduación, lo que puede definirse como ", _jsx(Tooltip, {
          title: "Finalización a tiempo",
          content: "Niños que finalizan los niveles de educación hasta 3 o 5 años después de la edad normal del último curso",
          children: "finalización a tiempo"
        }), ". Sin embargo, muchos niños finalizan sus estudios incluso más tarde, lo que puede denominarse ", _jsx(Tooltip, {
          title: "finalización posterior",
          content: "Niños que finalizan los niveles de educación hasta 8 años después de la edad normal del último curso",
          children: "finalización posterior"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["En el gráfico a continuación se aprecia que en Angola, por ejemplo, existe una diferencia de casi 20 puntos porcentuales entre la ", _jsx(HighlightByIndex, {
          index: "0",
          children: "finalización a tiempo "
        }), " (64%) y la ", _jsx(HighlightByIndex, {
          index: "1",
          children: "finalización posterior"
        }), " (82%) en la educación primaria."]
      }), _jsx(Figure, {
        id: "COMPLETION"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "conclusión",
      children: "Conclusión"
    }), "\n", _jsx(_components.p, {
      children: "El momento de matriculación de los niños, su edad y si finalizan o no sus estudios son preocupaciones políticas clave."
    }), "\n", _jsxs(_components.p, {
      children: ["Los siguientes temas de este sitio examinan qué tan cerca estamos de lograr la ", _jsx(PageLink, {
        name: "equidad",
        children: "equidad"
      }), " en la educación, qué están ", _jsx(PageLink, {
        name: "aprendiendo",
        children: "aprendiendo"
      }), " los alumnos, qué tan buena es la ", _jsx(PageLink, {
        name: "calidad ",
        children: "calidad "
      }), " de su educación, y quién la ", _jsx(PageLink, {
        name: "financia",
        children: "financia"
      }), "."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-estimates.org",
            children: "Visualizing Indicators of Education for the World (VIEW)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000382577",
            children: "New estimation confirms out-of-school population is growing in sub-Saharan Africa"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://resourcecentre.savethechildren.net/library/education-against-odds-meeting-marginalised-childrens-demands-quality-education",
            children: "Education above the odds – Save the Children"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining data on out-of-school children, Completion and learning to offer a more comprehensive view on SDG 4"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
